import Cookies from "js-cookie";

type BridgeStatus = "ACTIVE" | "PENDING" | "REJECTED";

export function getAccountsOrderFromCookies() {
  const accountsOrder = Cookies.get("accountsOrder");
  if (accountsOrder) {
    return JSON.parse(accountsOrder);
  }
}

export function setAccountsOrderInCookies(data: object) {
  Cookies.set("accountsOrder", JSON.stringify(data), { expires: 365 });
}

export function getIsBridgeActiveFromCookies() {
  return Cookies.get("isBridgeApproved");
}

export function setBridgeStatusInCookies(data: BridgeStatus) {
  Cookies.set("isBridgeApproved", data, { expires: 365 });
}
